import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { EventService, MapService } from '../../services';
import { ReportService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { BaseReportComponent } from './base-report.component';
import moment from 'moment';
import { IFuelLevelMapper } from '../../interfaces/fuel-level-mapper';
import { FuelLevelService } from 'src/app/services/fuel-level.service';

export enum OrderStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
}

@Component({
  selector: 'orders-report',
  templateUrl: './orders-report.component.html',
  styleUrls: ['./orders-report.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  moment = moment;
  public tags: any[] = [];
  public groupTags: any[] = [];
  public costCodes: any[] = [];
  public groupCostCodes: any[] = [];
  public departments: any[] = [];
  public teams: any[] = [];
  public regions: any[] = [];
  public depots: any[] = [];
  public orderStatuses: any[] = [];
  public taskTypes: any[] = [];
  public customers: any[] = [];
  public statusClosed = OrderStatus.Closed;
  public columns: { label: string; style: string }[];
  public maxTasks: number;
  public rows: any[] = [];
  private fuelLevelMappers: IFuelLevelMapper[] = [];

  constructor(
    reportService: ReportService<any, any>,

    eventService: EventService,
    private userService: UserService,
    private mapService: MapService,
    private taskService: TaskService,
    private fuelLevelService: FuelLevelService,
  ) {
    super(reportService, false, eventService);
    reportService.url = '/api/report/order';

    eventService.ReportChangedEvent.subscribe((input) => {
      this.parseReport(input);
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
    this.getFuelLevelMappers();
  }

  private getFuelLevelMappers() {
    this.fuelLevelService.getFuelLevels().then((fuelLevels) => {
      if (fuelLevels) {
        this.fuelLevelMappers = fuelLevels;
      }
    });
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
          this.callbackLoadFilterParam();
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.tags = [];
    this.groupTags = [];
    this.costCodes = [];
    this.groupCostCodes = [];
    this.departments = [];
    this.teams = [];
    this.regions = [];
    this.depots = [];
    this.orderStatuses = [];
    this.taskTypes = [];
    this.customers = [];

    if (this.filterParam) {
      this.tags.push({ label: 'Please Select', value: null });
      if (this.filterParam.tags) {
        if (this.organisationTypeId != 1) {
          this.filterParam.tags
            .sort((x) => x.id)
            .forEach((x) => {
              this.tags.push({ label: x.description, value: x.id });
            });
        } else {
          var groupTags = [];
          var orgKeys = [];
          this.filterParam.tags.forEach((x) => {
            if (!groupTags[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupTags[x.organisationName] = { organisationName: x.organisationName, items: [] };
            }

            groupTags[x.organisationName].items.push(x);
          });

          groupTags.sort((x) => x.organisationName);
          this.groupTags.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupTag = groupTags[orgKeys[i]];

            groupTag.items.forEach((item) => {
              this.groupTags.push({
                label: item.description,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.costCodes.push({ label: 'Please Select', value: null });
      if (this.filterParam.costcodes) {
        if (this.organisationTypeId != 1) {
          this.filterParam.costcodes
            .sort((x) => x.id)
            .forEach((x) => {
              this.costCodes.push({ label: x.name, value: x.id });
            });
        } else {
          var groupCostCodesTmp = [];
          var orgKeys = [];
          this.filterParam.costcodes.forEach((x) => {
            if (!groupCostCodesTmp[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupCostCodesTmp[x.organisationName] = {
                organisationName: x.organisationName,
                items: [],
              };
            }

            groupCostCodesTmp[x.organisationName].items.push(x);
          });

          groupCostCodesTmp.sort((x) => x.organisationName);

          this.groupCostCodes.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupCostCodeIns = groupCostCodesTmp[orgKeys[i]];

            groupCostCodeIns.items.forEach((item) => {
              this.groupCostCodes.push({
                label: item.name,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.departments.push({ label: 'Please Select', value: null });
      if (this.filterParam.departments) {
        this.filterParam.departments
          .sort((x) => x.id)
          .forEach((x) => {
            this.departments.push({ label: x.name, value: x.id });
          });
      }

      this.regions.push({ label: 'Please Select', value: null });
      if (this.filterParam.regions) {
        this.filterParam.regions
          .sort((x) => x.id)
          .forEach((x) => {
            this.regions.push({ label: x.name, value: x.id });
          });
      }

      this.depots.push({ label: 'Please Select', value: null });
      if (this.filterParam.depots) {
        this.filterParam.depots
          .sort((x) => x.id)
          .forEach((x) => {
            this.depots.push({ label: x.name, value: x.id });
          });
      }

      //this.orderStatuses.push({label: 'Please Select', value: null});
      if (this.filterParam.statuses) {
        this.filterParam.statuses
          .sort((x) => x.id)
          .forEach((x) => {
            this.orderStatuses.push({ label: x.name, value: x.id });
          });
      }

      this.taskTypes.push({ label: 'Please Select', value: null });
      if (this.filterParam.types) {
        this.filterParam.types
          .sort((x) => x.id)
          .forEach((x) => {
            this.taskTypes.push({ label: x.name, value: x.id });
          });
      }

      this.teams.unshift({ label: 'Please Select', value: null });
      if (this.filterParam.teams) {
        this.filterParam.teams
          .sort((x, y) => x.name.localeCompare(y.name))
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }

      this.customers.push({ label: 'Please Select', value: null });
      if (this.filterParam.customers) {
        this.filterParam.customers.forEach((x) => {
          this.customers.push({ label: x.label, value: x.value });
        });
      }
    }
  }

  changeSort(event) {
    var event2 = event;
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        completedDateFrom: {},
        completedDateTo: {},
        pickUpDateFrom: {},
        pickUpDateTo: {},
        tag: {},
        costCode: {},
        department: {},
        team: {},
        region: {},
        depot: {},
        status: {},
        type: {},
        customer: {},
        supplier: {},
      },
    };
  }

  departmentChange(event) {
    this.filterVal.filters.team = {};
    this.loadTeams(event.value);
  }

  loadTeams(departmentId) {
    this.teams = [];
    this.teams.push({ label: 'Please Select', value: null });
    if (departmentId == null) {
      if (this.filterParam.teams) {
        this.filterParam.teams
          .sort((x, y) => x.name.localeCompare(y.name))
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }
    }

    if (departmentId != null) {
      if (this.filterParam.teams) {
        this.filterParam.teams
          .filter((x) => x.departmentId == departmentId)
          .sort((x, y) => x.name.localeCompare(y.name))
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }
    }
  }

  private parseReport(input: any) {
    this.columns = [
      { label: 'Ord Ref', style: 'width: 100px' },
      { label: 'Job Ref', style: 'width: 100px' },
      { label: 'Customer', style: 'width: 100px' },
      { label: 'Department', style: 'width: 100px' },
      { label: 'Team', style: 'width: 100px' },
      { label: 'Supplier', style: 'width: 100px' },
      { label: 'Created', style: 'width: 100px' },
      { label: 'Pickup', style: 'width: 100px' },
      { label: 'Drop Off', style: 'width: 100px' },
      { label: 'Type', style: 'width: 100px' },
      { label: 'Scheduled Date', style: 'width: 100px' },
    ];

    if (this.organisationTypeId == 1) {
      this.columns.push({ label: 'Value', style: 'width: 100px' });
    }

    this.columns.push({ label: 'Min', style: 'width: 100px' });
    this.columns.push({ label: 'Max', style: 'width: 100px' });
    this.columns.push({ label: 'Final', style: 'width: 100px' });

    this.columns.push({ label: 'Status', style: 'width: 100px' });

    if (this.organisationTypeId == 3 || this.organisationTypeId == 4) {
      this.columns.push({ label: 'Region', style: 'width: 100px' });
      this.columns.push({ label: 'Depot', style: 'width: 100px' });
    }

    this.columns.push({ label: 'Cost Code', style: 'width: 100px' });
    this.columns.push({ label: 'Tags', style: 'width: 100px' });
    this.columns.push({ label: 'Number of Tasks', style: 'width: 100px' });
    this.columns.push({ label: 'PO Number', style: 'width: 100px' });

    this.maxTasks = 0;

    input.items.forEach((x) => {
      if (x.tasks.length > this.maxTasks) {
        this.maxTasks = x.tasks.length;
      }
    });

    if (this.maxTasks > 0) {
      for (let cnt = 1; cnt <= this.maxTasks; cnt++) {
        this.columns.push({ label: 'Last Pickup From', style: 'width: 100px' });
        this.columns.push({ label: 'Last Pickup To', style: 'width: 100px' });
        this.columns.push({ label: 'Postcode From', style: 'width: 100px' });
        this.columns.push({ label: 'Postcode To', style: 'width: 100px' });
        this.columns.push({ label: 'Vehicle', style: 'width: 100px' });
        this.columns.push({ label: 'Reg', style: 'width: 100px' });
        this.columns.push({ label: 'Mileage', style: 'width: 100px' });
        this.columns.push({ label: 'Time', style: 'width: 100px' });
        this.columns.push({ label: 'Pickup Odo', style: 'width: 100px' });
        this.columns.push({ label: 'Dropoff Odo', style: 'width: 100px' });
        this.columns.push({ label: 'Pickup Fuel', style: 'width: 100px' });
        this.columns.push({ label: 'Dropoff Fuel', style: 'width: 100px' });
      }
    }

    input.items.forEach((x) => {
      let row: { value: any; cellType?: string; dateFormat?: string }[] = [
        { value: x.orderRef },
        { value: x.jobNumber },
        { value: x.customerName },
        { value: x.department },
        { value: x.team },
        { value: x.supplierName },
        { value: x.dateCreated, cellType: 'date', dateFormat: 'DD/MM/YY' },
        { value: x.lastPickUp, cellType: 'date', dateFormat: 'DD/MM/YY' },
        { value: x.lastDropOff, cellType: 'date', dateFormat: 'DD/MM/YY' },
        { value: x.movementType },
        { value: x.scheduledDate, cellType: 'date', dateFormat: 'DD/MM/YY' },
      ];

      if (this.organisationTypeId == 1) {
        row.push({ value: x.amount, cellType: 'currency' });
      }

      row.push({
        value: !x.isOverridePrice && x.statusId != this.statusClosed ? x.transactionMin : null,
        cellType: 'currency',
      });
      row.push({
        value: !x.isOverridePrice && x.statusId != this.statusClosed ? x.transactionMax : null,
        cellType: 'currency',
      });
      row.push({
        value: x.isOverridePrice || x.statusId == this.statusClosed ? x.transactionSum : null,
        cellType: 'currency',
      });

      row.push({ value: x.status });

      if (this.organisationTypeId == 3 || this.organisationTypeId == 4) {
        row.push({ value: x.region });
        row.push({ value: x.depot });
      }

      row.push({ value: x.costCodes });
      row.push({ value: x.tags.map((z) => z.tag).join(' ') });
      row.push({ value: x.poNumber ? x.tasks.length : 0 });
      row.push({ value: x.poNumber });

      x.tasks.forEach((i) => {
        row.push({
          value: i.pickupEarliestDateTime,
          cellType: 'date',
          dateFormat: 'ddd DD MM HH:mm',
        });
        row.push({
          value: i.pickupLatestDateTime,
          cellType: 'date',
          dateFormat: 'ddd DD MM HH:mm',
        });
        row.push({ value: i.pickupLocation.postcode });
        row.push({ value: i.dropoffLocation.postcode });
        row.push({ value: i.vehicle.make + ' ' + i.vehicle.model });
        row.push({ value: i.registrationNumber });
        row.push({ value: this.mapService.getMiles(i.distance) });
        row.push({ value: i.estimateTime });
        row.push({ value: i.pickupOdometer });
        row.push({ value: i.dropoffOdometer });
        row.push({ value: i.vehicle.isElectric ? i.pickupFuel : this.getFuelString(i.pickupFuel) });
        row.push({
          value: i.vehicle.isElectric ? i.dropoffFuel : this.getFuelString(i.dropoffFuel),
        });
      });

      this.rows.push({ cells: row });
    });
  }

  private getFuelString(fuel: number): string {
    const fuelLevel = this.fuelLevelMappers.find((x) => x.fuelLevel == fuel);
    return fuelLevel?.fuelLevelName;
  }
}
